module.exports = __webpack_public_path__ + "img/kasua_logo.139e9666.jpg";